import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsTracker"] */ "/app/sections/analytics-tracker/analytics-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YaAnalyticsScript"] */ "/app/sections/analytics-tracker/ya-analytics-script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/sections/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/sections/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BurgerMenu"] */ "/app/sections/header/ui/burger-menu/burger-menu.tsx");
;
import(/* webpackMode: "eager" */ "/app/sections/header/ui/modal-footer/modal-footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TagLink"] */ "/app/shared/ui/tag-link/tag-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/app/shared/ui/text/text.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/utils/common.js");
;
import(/* webpackMode: "eager" */ "/app/shared/utils/hooks.tsx");
;
import(/* webpackMode: "eager" */ "/app/styles/foundation/index.scss");
